<template>
  <div>
    <a-select
      v-if="funType == 'select'"
      :maxLength="64"
      style="width: 100%;"
      v-model:value="valueModel"
      :disabled="disabled"
      placeholder="请输入"
    >
      <a-select-option
        v-for="(item, index) in list"
        :value="item.value"
        :key="index"
      >
        {{ item.label }}</a-select-option
      >
    </a-select>
    <a-input
      v-if="funType == 'input'"
      style="width: 100%;"
      placeholder="请输入"
      v-model:value="valueModel"
    ></a-input>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
const props = defineProps({
  value: undefined,
  disabled: Boolean,
  list: Array,
  funType: String
})

const emit = defineEmits(['update:value'])

const valueModel = computed({
  get: () => props.value,
  set: val => {
    emit('update:value', val)
  }
})
</script>
